import type { Appearance, Stripe } from "@stripe/stripe-js";
import { getColor } from "@/util/theme";

let stripePromise: Promise<Stripe | null> | null = null;

export function getStripePromise() {
	if (!stripePromise) {
		stripePromise = import("@stripe/stripe-js").then((m) =>
			m.loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY),
		);
	}
	return stripePromise;
}

export const getAppearance = (): Appearance => {
	const base100 = getColor("base-100");
	const baseContent = getColor("base-content");
	const error = getColor("error");

	return {
		theme: "night",
		variables: {
			colorPrimary: baseContent || "oklch(0.869 0.022 252.894)", // IOS Blue
			colorBackground: base100 || "oklch(0.253 0.012 255.856)", // Base 100
			colorText: baseContent || "oklch(0.869 0.022 252.894)", // Base Content
			colorDanger: error || "oklch(0.627 0.265 30.347)", // Error
			fontFamily: "system-ui, sans-serif",
			borderRadius: "8px",
		},
	};
};
